import { MarbleItem } from 'src/components/MarbleItem'
import type { Marble } from 'src/types/domain/Marble'

type Props = Readonly<{
  marble: Marble
}>

export function SimpleMarbleItem({ marble }: Props) {
  return (
    <div className="simple-marble-position">
      <MarbleItem className={`marble-${marble.color}`} key={marble.uuid} marble={marble} />
    </div>
  )
}
